module.exports = __webpack_public_path__ + "static/desktop/img/hero-en2.6542d413.jpg";